import Vue from 'vue'
import store from '@/store'

const Loading = {
    setLoading(show = true, message = 'Carregando'){
        const paylod = { show, message }
        store.commit('utils/setLoading', paylod)
    }
}

Vue.prototype.$loading = Loading

export default Loading
